module.exports = __webpack_public_path__ + "static/corvidConsulting-db5f90ba476151f70b42b447975b7242.png";